import React, { useState } from "react";
import MillieImg from "../assets/images/millie-cartoon.png";

export default function MillieWave() {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Speech bubble (LEFT side so it won't get cut off at the top) */}
      <div
        className={`absolute right-full top-1/2 -translate-y-1/2 mr-3 bg-white text-gray-800 px-4 py-2 rounded-xl shadow-md text-sm whitespace-nowrap transition-opacity duration-300 ${
          hovered ? "opacity-100" : "opacity-0"
        }`}
      >
        Hi! I’m Millie 👋
        {/* little arrow pointing to Millie */}
        <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 bg-white rotate-45"></div>
      </div>

      {/* Millie image */}
      <img
        src={MillieImg}
        alt="Millie waving"
        loading="lazy"
        className={`
          w-20 md:w-24 cursor-pointer
          transition-transform duration-300
          ${hovered ? "animate-bounce-once" : ""}
        `}
        style={{ transformOrigin: "70% 70%" }}
      />

      {/* Invisible waving hand layer */}
      <div
        className={`
          absolute inset-0
          ${hovered ? "animate-wave" : ""}
        `}
        style={{ transformOrigin: "70% 70%" }}
      />
    </div>
  );
}
